import React, { Suspense } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as RoutesApp,
} from "react-router";
import { PageLoader } from "./components/PageLoader";
import { Layout } from "./Layout";
import { NotFound } from "./notFound";
import { ListaCertificadosAnaliseLaboratorial } from "./pages/analiseLaboratorial/certificados";
import { NovoCertificadoAnaliseLaboratorial } from "./pages/analiseLaboratorial/certificados/novoCertificado";
import { ListaRequisicoesAnaliseLaboratorial } from "./pages/analiseLaboratorial/requisicoes";
import { EdicaoRequisicaoAnaliseLaboratorial } from "./pages/analiseLaboratorial/requisicoes/edicaoRequisicao";
import { NovaRequisicaoAnaliseLaboratorial } from "./pages/analiseLaboratorial/requisicoes/novaRequisicao";
import { VisualizacaoAnaliseLaboratorial } from "./pages/analiseLaboratorial/visualizacaoAnaliseLaboratorial";
import { ListaPerfil } from "./pages/gerenciamentoPerfil";
import { Inicio } from "./pages/inicio";
import { Login } from "./pages/login";
import { ListaRelatoriosAM } from "./pages/relatorioAM/cadastramento";
import { EdicaoRelatorioAM } from "./pages/relatorioAM/cadastramento/edicaoRelatorioAM";
import { NovoRelatorioAM } from "./pages/relatorioAM/cadastramento/novoRelatorioAM";
import { VisualizacaoRAM } from "./pages/relatorioAM/cadastramento/visualizacaoRAM";
import { PlanoAcaoRelatorioAM } from "./pages/relatorioAM/planoAcao";
import { NovoPlanoAcaoRelatorioAM } from "./pages/relatorioAM/planoAcao/novo";
import { NovoParecerRelatorioAM } from "./pages/relatorioAM/planoAcao/novoParecer";
import { RemocaoParecerRelatorioAM } from "./pages/relatorioAM/planoAcao/remocaoParecer";
import { VisualizacaoPlanoAcaoRAM } from "./pages/relatorioAM/planoAcao/visualizacaoPlanoAcao";
import { ListaTermosNotificacao } from "./pages/termoNotificacao/cadastramento";
import { EdicaoTermoNotificacao } from "./pages/termoNotificacao/cadastramento/edicaoTermoNotificacao";
import { NovoTermoNotificacao } from "./pages/termoNotificacao/cadastramento/novoTermoNotificacao";
import { SaneamentoTermosNotificacao } from "./pages/termoNotificacao/saneamento";
import { NovoParecer } from "./pages/termoNotificacao/saneamento/novoParecer";
import { NovoSaneamento } from "./pages/termoNotificacao/saneamento/novoSaneamento";
import { VisualizacaoSaneamento } from "./pages/termoNotificacao/saneamento/visualizacaoSaneamento";
import { VisualizacaoPrintTermoNotificacao } from "./pages/termoNotificacao/VisualizacaoPrintTermoNotificacao";
import { VisualizacaoTermoNotificacao } from "./pages/termoNotificacao/visualizacaoTermoNotificacao";

function RouteWithLayout({ element }: { element: React.ReactNode }) {
  return <Layout>{element}</Layout>;
}

export function Routes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <RoutesApp>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/inicio"
            element={<RouteWithLayout element={<Inicio />} />}
          />
          <Route
            path="/analises-laboratoriais/requisicoes/lista"
            element={
              <RouteWithLayout
                element={<ListaRequisicoesAnaliseLaboratorial />}
              />
            }
          />
          <Route
            path="/analises-laboratoriais/requisicoes/novo"
            element={
              <RouteWithLayout
                element={<NovaRequisicaoAnaliseLaboratorial />}
              />
            }
          />
          <Route
            path="/analises-laboratoriais/requisicoes/lista/editar/:offlineId"
            element={
              <RouteWithLayout
                element={<EdicaoRequisicaoAnaliseLaboratorial />}
              />
            }
          />

          <Route
            path="/analises-laboratoriais/visualizar/:id"
            element={
              <RouteWithLayout element={<VisualizacaoAnaliseLaboratorial />} />
            }
          />

          <Route
            path="/analises-laboratoriais/certificados/lista"
            element={
              <RouteWithLayout
                element={<ListaCertificadosAnaliseLaboratorial />}
              />
            }
          />

          <Route
            path="/analises-laboratoriais/certificados/novo/:requisicaoId"
            element={
              <RouteWithLayout
                element={<NovoCertificadoAnaliseLaboratorial />}
              />
            }
          />

          <Route
            path="/termos-notificacao/lista"
            element={<RouteWithLayout element={<ListaTermosNotificacao />} />}
          />

          <Route
            path="/termos-notificacao/novo"
            element={<RouteWithLayout element={<NovoTermoNotificacao />} />}
          />

          <Route
            path="/termos-notificacao/visualizar/:id"
            element={
              <RouteWithLayout element={<VisualizacaoTermoNotificacao />} />
            }
          />

          <Route
            path="/termos-notificacao/lista/editar/:offlineId"
            element={<RouteWithLayout element={<EdicaoTermoNotificacao />} />}
          />

          <Route
            path="/termos-notificacao/plano-acao"
            element={
              <RouteWithLayout element={<SaneamentoTermosNotificacao />} />
            }
          />

          <Route
            path="/termos-notificacao/plano-acao/novo/:termoId"
            element={<RouteWithLayout element={<NovoSaneamento />} />}
          />

          <Route
            path="/termos-notificacao/plano-acao/parecer/:termoId"
            element={<RouteWithLayout element={<NovoParecer />} />}
          />

          <Route
            path="/termos-notificacao/plano-acao/visualizar/:id"
            element={<RouteWithLayout element={<VisualizacaoSaneamento />} />}
          />

          <Route
            path="/termos-notificacao/publico/:codigoVerificador/pdf"
            element={<VisualizacaoPrintTermoNotificacao />}
          />

          <Route
            path="/RAM/lista"
            element={<RouteWithLayout element={<ListaRelatoriosAM />} />}
          />

          <Route
            path="/RAM/novo"
            element={<RouteWithLayout element={<NovoRelatorioAM />} />}
          />

          <Route
            path="/RAM/lista/editar/:offlineId"
            element={<RouteWithLayout element={<EdicaoRelatorioAM />} />}
          />

          <Route
            path="/RAM/visualizar/:id"
            element={<RouteWithLayout element={<VisualizacaoRAM />} />}
          />

          <Route
            path="/RAM/plano-acao"
            element={<RouteWithLayout element={<PlanoAcaoRelatorioAM />} />}
          />

          <Route
            path="/RAM/plano-acao/novo/:relatorioId"
            element={<RouteWithLayout element={<NovoPlanoAcaoRelatorioAM />} />}
          />

          <Route
            path="/RAM/plano-acao/visualizar/:id"
            element={<RouteWithLayout element={<VisualizacaoPlanoAcaoRAM />} />}
          />

          <Route
            path="/RAM/plano-acao/parecer/:relatorioId"
            element={<RouteWithLayout element={<NovoParecerRelatorioAM />} />}
          />

          <Route
            path="/RAM/plano-acao/parecer/remover/:relatorioId"
            element={
              <RouteWithLayout element={<RemocaoParecerRelatorioAM />} />
            }
          />

          <Route
            path="/perfis"
            element={<RouteWithLayout element={<ListaPerfil />} />}
          />

          <Route path="*" element={<NotFound />} />
        </RoutesApp>
      </Suspense>
    </BrowserRouter>
  );
}
